import {
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
  useEffect,
  useRef,
  useState,
} from "react";
import CameraIcon from "../../assets/images/CameraIcon";
import Input from "./cta/Input";
import SelectDropdown from "./cta/Select";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  errorMessageJson,
  reSetUserRegistrationPayload,
  resetUserRegistrationNewpayload,
  userRegistrationNewPayload,
  validationTemplatePayload,
} from "../../store/slices/userOnboardSlice";
import { userRegistrationPayload } from "../../store/slices/userOnboardSlice";
import ProfileIcon3 from "../../assets/images/ProfileIcon3";
import {
  Constants,
  ErrorConstant,
  OnboardConstants,
  PlaceHolderText,
  StaffListConstants,
} from "../../constants/constants";
import Button from "./cta/Button";
import { AddEducationButtonStyle } from "./styles/CommonStyles";
import { json } from "stream/consumers";
import { add, set, sub } from "date-fns";
import {
  STATUS,
  resetFaceRecignitionStatus,
  resetRegisterUserStatus,
} from "../../store/slices/userDetailslice";
import { saveCameraStream } from "../../store/slices/loginSlice";
import CameraPopup from "./CameraPopup";
import Loader from "./styles/Loader";
import EditIconWithColor from "../../assets/images/EditIconWithColor";
import BriefcaseIconWithColor from "../../assets/images/BriefcaseIconWithColor";
import RolesAndPermissionIconWithColor from "../../assets/images/RolesAndPermissionIconWithColor";
import BankDetailIcon from "../../assets/images/BankDetailIcon";
import React from "react";
import CustomMenuList from "./CustomMenuList";
import SelectDropDown, {
  ActionMeta,
  MultiValue,
  components,
  SingleValue,
} from "react-select";
import { MultiSelectDropDownOptionsComponent } from "../MultiSelectDropDownOptionsComponent";
import { CustomDropdownIcon } from "./CustomDropDownIcon";
import http from "../../rest/http";
import { TypeAndSpecialization } from "../../store/slices/rolesSlice";
import InfoIcon from "../../assets/images/InfoIcon";
import {
  registerUserDetailsAsync,
  verifyPrimaryPhonenumberAsync,
} from "../../store/thunks/userThunk";
import RolesAndPermissionTable from "./RolesAndPermissionTable";
import PopUpIcon from "../../assets/images/PopUpIcon";
import PopupModalWithCancelButton from "./PopupModalWithCancelButton";
import LoaderPopupModel from "./LoaderPopup";
import { useNavigate } from "react-router";
import PopupModal from "./PopupModal";
import ErrorIcon from "../../assets/images/ErrorIcon";
import WarningIcon from "../../assets/images/WarningIcon";
import EducationalDetailsTable from "./EducationalDetailsTable";
import WorkExperienceTable from "./WorkExperienceTable";
import BranchesIcon from "../../assets/images/BranchesIcon";
import { todayDate } from "../../utils/DataTime";

interface ValidationRule {
  value: string;
  errorMessage: string;
}

type AttributeArray = {
  attributeId: string;
  name: string;
  value: string;
};

interface SubSegment {
  subSegmentId: number;
  name: string;
  attributes: AttributeArray[];
  canMultiple: boolean;
  subSegmentOrder: number;
}

// interface Segment {
//   segmentId: number;
//   name: string;
//   subSegments: SubSegment[];
// }

interface DropdownOption {
  value: any;
  id?: number; // For Training options
  title?: string; // For Training options
  sapDealerCode?: string; // For Dealership options
  tempDmsBranchSequence?: number; // For Dealership options
  name?: string; // For Dealership options
}

interface FormData {
  segments: Segment[];
}
interface Attribute {
  options: any;
  label: string | undefined;
  name: string;
  isRequired: boolean;
  inputType: string;
  validationRules?: ValidationRule[];
  apiUrl?: string;
  dependsOn?: string;
  attributeOrder?: any;
}

interface RequiredFieldInfo {
  required: boolean;
  pattern: string | null;
  errorMessage: string | null;
}
interface Subsegment {
  name: string;
  attributes: Attribute[];
  canMultiple: boolean;
  subSegmentOrder: number;
  subSegmentId: number;
}

interface Segment {
  name: string;
  description: string;
  segmentOrder: number;
  segmentId: number;
  subSegments: SubSegment[];
}

interface SubSegmentPayload {
  subSegmentId: number;
  name: string;
  attributes: AttributeArray[];
}

const PersonalInformationDynamic = ({
  isEditMode = false,
  jsonobj,
  order,
  setSegmentOrder,
  onClickToNextPage,
  validateForm,
  requiredFieldsWithPattern,
  setCapturedImage,
  setCapturedFileImage,
  capturedImage,
  capturedFileImage,
  selectedMenu,
  setSelectedMenu,
  onClickToPreviousPage,
  setEditPayloadjson,
  jsonObjForEdit,
  indexOfValueToBeModified,
  addMoreEducationalInfo,
  addmoreEducationOrder,
  setJsonForEditFlow, 
  addMoreWorkInfo,
  addmoreWorkOrder,
  showEducationTableInEditFlow,
  showWorkTableInEditFlow,
  addMoreRolesInfo,
  addmoreRolesOrder,
  showRolesTableInEditFlow,
  isSaveButtonCLicked,
  setIsErrors,
  setIsSaveButtonClicked,
  errors,
  setErrors,
  setIsBranchesManditory,
  setIsSpecilizationManditory,
  isWorkDetailsNullRef,
}: {
  isEditMode?: boolean;
  jsonobj: Segment[];
  order: number;
  setSegmentOrder?: any;
  onClickToNextPage?: any;
  validateForm?: any;
  requiredFieldsWithPattern?: any;
  setCapturedImage?: any;
  setCapturedFileImage?: any;
  capturedImage?: any;
  capturedFileImage?: any;
  selectedMenu?: number;
  setSelectedMenu?: any;
  onClickToPreviousPage?: any;
  setEditPayloadjson?: (value: any) => void;
  jsonObjForEdit?: any;
  indexOfValueToBeModified?: any;
  addMoreEducationalInfo?: any;
  addmoreEducationOrder?: any;
  setJsonForEditFlow?: any;
  addMoreWorkInfo?: any;
  addmoreWorkOrder?: any;
  showEducationTableInEditFlow?: any;
  showWorkTableInEditFlow?: any;
  addMoreRolesInfo?: any;
  addmoreRolesOrder?: any;
  showRolesTableInEditFlow?: any;
  isSaveButtonCLicked?: any;
  setIsErrors?: (value: any) => void;
  setIsSaveButtonClicked?:any;
  errors?: any;
  setErrors?:any;
  setIsBranchesManditory?: any;
  setIsSpecilizationManditory?: any;
  isWorkDetailsNullRef?: any;
}) => {
  const [jsonForEdit, setJsonForEdit] = useState<any>([]);
  const userDetails = useSelector((state: RootState) => state.userDetails.user);

  const navigate = useNavigate();
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const dispatch = useDispatch<AppDispatch>();
  const ValidateJson = useSelector(
    (state: RootState) =>
      state.userOnboardingJsonDetails?.validationTempleteJson
  );
  const userDetailJsonObj = useSelector(
    (state: RootState) => state.userOnboardingJsonDetails?.userDetailResponse
  );

  const userRegisterResponseStatus = useSelector(
    (state: RootState) => state.userOnboardingJsonDetails?.registerUserStatus
  );
  useEffect(() => {
    if (addMoreEducationalInfo || addMoreWorkInfo || addMoreRolesInfo) {
      setJsonForEdit(jsonObjForEdit);
    } else {
      setJsonForEdit(JSON.parse(JSON.stringify(userDetailJsonObj)));
    }
  }, []);
  const isEkycRequired = useSelector(
    (state: RootState) => state?.userOnboardingJsonDetails?.isEkycRequired
  );
  const userConflictingStatus: any = useSelector(
    (state: RootState) => state.userDetails?.registerUserConflictingStatus
  );
  const errorUserRegistrationMsg = useSelector(
    (state: RootState) => state.userDetails?.userRegisterErrorMsg
  );
  const errorJson = useSelector(
    (state: RootState) => state.userOnboardingJsonDetails?.errorJson
  );
  const registerUserStatus: string = useSelector(
    (state: RootState) => state.userDetails?.registerUserStatus
  );
  const payloadForRegistrationJson = useSelector(
    (state: RootState) =>
      state.userOnboardingJsonDetails?.newPayloadForUserRegistration?.formSegments
  );
  // const isBankDetailsManditoryForEditFlow = useSelector((state: RootState) =>state.userOnboardingJsonDetails?.isBankDetailsRequired);
  const payloadForRegistrationJsonApiCall = useSelector(
    (state: RootState) =>
      state.userOnboardingJsonDetails?.newPayloadForUserRegistration
  );
  const isFaceExists = useSelector(
    (state: RootState) =>
      state.userOnboardingJsonDetails?.payloadForUserRegistration
  );
  const [selectedSpecializationList, setSelectedSpecializationList] = useState<
    TypeAndSpecialization[] | null
  >(null);
  const [selectedBranchesList, setSelectedbranchesList] = useState<
    DropdownOption[] | null
  >(null);
  const [trainingOrBranchesOptions, setTrainingOrBranchesOptions] = useState<
    DropdownOption[] | null
  >(null);
  interface SpecializationOption {
    id: number;
    name: string;
    desc: string;
    multipleAllowed: boolean;
  }
  const [canMultiplePayload, setCanMultiplePayload] = useState<boolean>(false);
  const [showEducationaltable, setShowEducationalTable] =
    useState<boolean>(false);
  const [showWorktable, setShowWorkTable] = useState<boolean>(false);
  const [specilizationOptions, setSpecilizationOptions] = useState<
    OptionType[]
  >([]);
  const [speclizationIsManditory, setSpeclizationIsManditory] = useState(false);
  const [bankDetailsManditory, setBankDetailsManditory] = useState(false);
  const [showCreateProfilePopUp, setShowCreateProfilePopUp] = useState(false);
  const [confirmedImage, setConfirmedImage] = useState(false);
  const [multipleAllowed, setMultipleAllowed] = useState(false);
  const [phoneNumberExists, setPhoneNumberExists] = useState(false);
  const [isSpecialization, setIsSpecialization] = useState<boolean>(true);
  const [showFullPhoneNumberError, setShowFullPhoneNumberError] =
    useState<boolean>(false);

  // useEffect(() => {
  //   const orderObject = jsonobj?.[order] ?? {};
  //   const validateTemplateJson = validationTemplateJson(orderObject);
  //   dispatch(validationTemplatePayload(validateTemplateJson));
  //   const errorJson = errorMessagepayloadJson(orderObject);
  //   dispatch(errorMessageJson(errorJson));
  // }, []);
  useEffect(() => {
    // console.log("jsonobj", jsonobj, showEducationaltable);
  });
  const [subsegmentData, setSubsegmentData] = useState<Record<string, any[]>>(
    {}
  );
  const [currentJson, setCurrentJson] = useState<Record<string, string>>({});
  const [jsonForApiCall, setJsonForApiCall] = useState<Record<string, string>>(
    {}
  );
  const payloadIndex = useRef(0);
  const payloadIndexForTable = useRef(0);
  const [payloadOrderId, setPayloadId] = useState(null);
  const [payload, setPayload] = useState<{ [key: string]: any }>({});
  const [tablePayload, setTablePayload] = useState<{ [key: string]: any }>({});
  // const [updatedArray, setUpdatedArray] = useState({});
  const [payloadOrderIdForTable, setPayloadIdforTable] = useState(null);
  const [subSegmentPayload, setSubSegmentPayload] = useState<SubSegmentPayload>(
    {
      subSegmentId: 0, // Default value
      name: "",
      attributes: [],
    }
  );
  const subSegementPayloadRef = useRef<SubSegmentPayload>({ 
    subSegmentId: 0, // Default value
    name: "",
    attributes: [],
  }
);
  const [subSegmentPayloadForbranches, setSubSegmentPayloadForBranches] =
    useState<SubSegmentPayload>({
      subSegmentId: 0, // Default value
      name: "",
      attributes: [],
    });
  const [showPopUp, setShowPopUp] = useState(false);
  const [showRolesTable, setShowRolesTable] = useState(false);
  const [attributesArray, setAttributesArray] = useState<AttributeArray[]>([]);
  const [attributesArrayForBranches, setAttributesArrayForBranches] = useState<
    AttributeArray[]
  >([]);
  const attributesArrayRef = useRef<AttributeArray[]>([]);
  const [attributesArrayForTable, setAttributesArrayForTable] = useState<
    AttributeArray[]
  >([]);
  const attributesRef = useRef<AttributeArray[]>([]);
  const subSegmentRef = useRef<any[]>([]);
  const attributesRefForTable = useRef<AttributeArray[]>([]);
  const subSegmentRefForTable = useRef<any[]>([]);
  const subSegmentRefForTableForvalidation = useRef<any>(1);
  const branchesSubsegementPayloadRef = useRef<any>();

  const [educational,setEducational] = useState(false);
  const [Work,setWork] = useState(false);
  const [educationalTable,setEducationalTable] = useState(false);
  const [WorkTable,setWorkTable] = useState(false);
  // State for the array of JSON objects
  const [jsonArray, setJsonArray] = useState<Record<string, string>[]>([]);
  const hasFace =
    jsonobj?.[order]?.subSegments?.some((subsegment) =>
      subsegment?.attributes?.some(
        (attribute) => attribute?.name === "face" // Check for the "face" attribute
      )
    ) ?? false;
  const [isCameraActive, setIsCameraActive] = useState(false);
  const verifyFaceRecognitionAsyncStatus = useSelector(
    (state: RootState) => state.userDetails?.verifyFaceRecognitionAPIStatus
  );

  const [subSegmentList, setSubSegmentList] = useState<any[]>([]);
  const [subSegmentListForTable, setSubSegmentListForTable] = useState<any[]>(
    []
  );
  const [faceErrorMessage, setFaceErrorMessage] = useState<string>("");
  useEffect(() => {
    setSubSegmentList([]);
    subSegmentRef.current = [];
    setAttributesArray([]);
    attributesRef.current = [];
  }, [jsonobj]);

  useEffect(() => {
    if (
      registerUserStatus === STATUS.SUCCESS ||
      registerUserStatus === STATUS.FAILED
    ) {
      openModal();
    }
  }, [registerUserStatus]);

  const startCamera = async () => {
    dispatch(resetFaceRecignitionStatus());
    setCapturedImage("");
    setIsCameraActive(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      dispatch(saveCameraStream(stream));

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error: any) {
      setIsCameraActive(false);
      if (error.name === "NotFoundError") {
        // handleAlert("Camera not found.");
      } else if (error.name === "NotAllowedError") {
        // handleAlert("Permission to access camera was declined.");
      } else {
        // handleAlert("Error accessing camera.");
      }
    }
  };

  const addImageToUserInfo = (payloadName = "face") => {
    dispatch(
      userRegistrationPayload({ key: payloadName, value: capturedFileImage })
    );
  };

  const subsegmentIcons: Record<string, React.ComponentType<any>> = {
    "Personal Information": ProfileIcon3, // Example
    "Educational Information": EditIconWithColor, // Example
    "Work Experience": BriefcaseIconWithColor,
    Roles: RolesAndPermissionIconWithColor,
    "Bank account details": BankDetailIcon,
    Branches: BranchesIcon,
  };

  const cameraStream = useSelector(
    (state: RootState) => state.loginDetails?.cameraStream
  );
  const captureImage = () => {
    const canvas = document.createElement("canvas");
    if (videoRef.current) {
      const scaleFactor = 1;
      canvas.width = videoRef.current.videoWidth * scaleFactor;
      canvas.height = videoRef.current.videoHeight * scaleFactor;
      canvas
        ?.getContext("2d")
        ?.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

      let dataUri = canvas.toDataURL("image/jpeg");
      setCapturedImage(dataUri);

      let byteString = atob(dataUri.split(",")[1]);
      let mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ab], { type: mimeString });
      let file = new File([blob], "image.jpg", { type: mimeString });
      setCapturedFileImage(file);
      closeCamera();
    }
  };

  const closeCamera = () => {
    if (cameraStream) {
      const tracks: MediaStreamTrack[] = cameraStream.getTracks(); // Get all tracks from the stream
      tracks.forEach((track) => track.stop()); // Stop each track
      if (videoRef.current) {
        videoRef.current.srcObject = null; // Clear video source to stop displaying camera feed
      }
    }
  };

  const cameraError = useSelector(
    (state: RootState) => state.userDetails?.faceRecognitionErrorMsg
  );
  const cameraErrorstatus = useSelector(
    (state: RootState) => state.userDetails?.verifyFaceRecognitionAPIStatus
  );


  const validateFormData = (schema: any[], formData: any[]) => {
    let errors: any = {};

    // Convert formData array into an object for easy lookup
    const formValues: any = {};
    formData.forEach((item) => {
      formValues[item?.name] = item?.value;
    });
    if(order === 3 && bankDetailsManditory){
      schema.forEach((field) => {
        const fieldValue = formValues[field?.name];
      if (!fieldValue || fieldValue.trim() === "" ) {
        errors[field?.name] = `${field?.label} is required`;
        return;
      }
        })
    }
    // Iterate over the schema to validate each field

    schema.forEach((field) => {
      if (field?.name === "face" && (capturedFileImage === undefined || capturedFileImage === null || capturedFileImage === "")) {
        setFaceErrorMessage("Face image is required");
        errors[field?.name] = "Face image is required";
        return;
      }
      if (field?.isRequired && field?.name !== "face") {



        const fieldValue = formValues[field?.name];
        // Check if the required field is missing
        if (!fieldValue && field?.isRequired === true) {
          const trimmedValue = typeof fieldValue === "object" && fieldValue !== null
            ? fieldValue.value?.trim?.()
            : fieldValue?.trim?.();
          if ((trimmedValue === "" || trimmedValue === undefined || trimmedValue === null) && field?.isRequired) {
            errors[field?.name] = `${field?.label} is required`;
            return;
          }
        }
        if (field.name === "primaryPhoneNumber" && fieldValue?.length < 10) {
          errors[field?.name] = `${field?.label} should be 10 digits`;
          return;
        }

        // Apply regex validation if any
        if (field.validationRules.length > 0) {
          field.validationRules.forEach(
            (rule: {
              name: string;
              value: string | RegExp;
              errorMessage: any;
            }) => {
              if (rule.name === "regex") {
                const regex = new RegExp(rule?.value);
                if (!regex.test(fieldValue)) {
                  errors[field?.name] = rule?.errorMessage;
                }
              }

              if (rule.name === "maxLength") {
                const maxLength = parseInt(String(rule?.value), 10);
                if (fieldValue?.length > maxLength) {
                  errors[field?.name] = rule?.errorMessage;
                }
              }

              if (rule.name === "minLength") {
                const minLength = parseInt(String(rule?.value), 10);
                if (fieldValue?.length < minLength) {
                  errors[field?.name] = rule?.errorMessage;
                }
              }
            }
          );
        }
      }
    });
    setErrors(errors);
    return errors; // Return an object with error messages for invalid fields
  };


  const mainValidateFunction = (subSegementId: any = 0) => {
    getLastSubsegmentDataForvalidatation();
    validateEducationalDetailsSegment();
    const simplifiedAttributes = jsonobj[order]?.subSegments[subSegementId]?.attributes
  .filter(attr => attr.value !== null && attr.value !== "") // keep only those with values
  .map(({ attributeId, name, value }) => ({
    attributeId,
    name,
    value
  }));
    const errorMessage = jsonobj[order]?.subSegments[0]?.canMultiple
      ? validateFormDataForMultiple(
          jsonobj[order]?.subSegments,
          latestSubSegmentsRef.current
        )
      : validateFormData(
          jsonobj[order]?.subSegments[subSegementId]?.attributes,
          isEditMode ? simplifiedAttributes : subSegementPayloadRef.current.attributes

        );
    return errorMessage;
  };
useEffect(() => {
  if(isSaveButtonCLicked && (order === 0 || order === 3)){
    const errorMessage = mainValidateFunction();
    console.log("errorMessage", errorMessage);
    if(Object.keys(errorMessage).length === 0){
      setIsErrors?.(false);
    }
    setIsSaveButtonClicked(false);
  }
},[isSaveButtonCLicked]);

const validateForRolesFunction = () => {
  const attributes = subSegmentRefForTable.current?.[subSegmentRefForTable.current.length - 1]?.attributes || [];
  const attributeMap = attributes.reduce((acc: any, attr: any) => {
    acc[attr.name] = attr.value;
    return acc;
  }, {});
  const specializationAttr = subSegmentRef.current.flatMap(item => item.attributes).find(attr => attr.name === "specializationIds");
  const newErrors: Record<string, string> = {};
  if (!attributeMap["deptId"]) {
    newErrors["deptId"] = "Department is required";
  }
  if (!attributeMap["groupId"]) {
    newErrors["groupId"] = "Group is required";
  }
  if (!attributeMap["roleId"]) {
    newErrors["roleId"] = "Role is required";
  }
  if(speclizationIsManditory){
        
    const isEmpty =
    !Array.isArray(specializationAttr?.value) || specializationAttr?.value?.length === 0;
    if (isEmpty) {
      newErrors["specializationIds"] = "Specialization is required";
    }
  
  }

const branchesAttr = branchesSubsegementPayloadRef.current?.attributes.find((attr: { name: string; }) => attr.name === "branches");

  if (!branchesAttr || !Array.isArray(branchesAttr?.value) || branchesAttr?.value?.length === 0) {
    newErrors["branches"] = "Branches is required";
  }
  if(subSegmentRefForTableForvalidation.current !== subSegmentRefForTable.current.length)
    {
      newErrors["deptId"] = "Department is required";
      newErrors["groupId"] = "Group is required";
      newErrors["roleId"] = "Role is required";
    }
  
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
  } else {
    setErrors({}); // clear previous errors if any
    setShowRolesTable(true);
  }
  return newErrors;
}

const onClickToNextPagee = () => {
  getLastSubsegmentDataForvalidatation();
  validateEducationalDetailsSegment();
  if (phoneNumberExists === false) {
    subSegementPayloadRef.current = {
      ...subSegementPayloadRef.current,
      attributes: attributesArrayRef.current,
    };
    const errorMessage = order === 2 ? validateForRolesFunction() : mainValidateFunction() ;
    if (canMultiplePayload && branchesSubsegementPayloadRef.current !== null && branchesSubsegementPayloadRef.current !=undefined) {
      subSegmentRef.current.push(branchesSubsegementPayloadRef.current);
    }
    if (errorMessage && Object.keys(errorMessage).length === 0  ) {
      const segmentData = {
        segmentId: jsonobj[order]?.segmentId,
        name: jsonobj[order]?.name,
        subSegments: canMultiplePayload
          ? subSegmentRef.current
          : [subSegementPayloadRef.current],
      };
      dispatch(userRegistrationNewPayload({ segment: segmentData }));
      if (jsonobj?.length !== order + 1) {
        subSegmentRef.current = [];
        payloadIndex.current = 0;
        payloadIndexForTable.current = 0;
        subSegmentRefForTable.current = [];
        setTablePayload({});
        setPayload({});
        setPayloadIdforTable(null);
        setPayloadId(null);
        setAttributesArray([]);
        setAttributesArrayForTable([]);
        attributesRef.current = [];
        attributesRefForTable.current = [];
        setSubSegmentListForTable([]);
        setSubSegmentList([]);
        setAttributesArrayForBranches([]);
        setTrainingOrBranchesOptions([]);
        setShowRolesTable(false);
        setSubSegmentPayloadForBranches({
          subSegmentId: 0, // Default value
          name: "",
          attributes: [],
        });
        setSubSegmentPayload({
          subSegmentId: 0, // Default value
          name: "",
          attributes: [],
        });
        setAttributesArrayForBranches([]);
        setAttributesArray([]);
        attributesArrayRef.current = [];
        setSelectedSpecializationList([]);
        branchesSubsegementPayloadRef.current = null;
        onClickToNextPage();
      } else {
        setShowCreateProfilePopUp(true);
      }
    }
  }
};


  const handleChangeFunction = async (
    e: React.ChangeEvent<HTMLInputElement>,
    payloadName: string,
    field: any,
    subsegment: any,
    canMultiple: any,
    attributeId: any
  ) => {
    let { value } = e.target;
    setCanMultiplePayload(jsonobj[order]?.subSegments[0]?.canMultiple);
    if (canMultiple) {
      handleInputChange(subsegment, payloadName, value, attributeId, "");
    } else {
      if (field?.apiUrl) {
        if (payloadName === "primaryPhoneNumber" && value.length < 10) {
          setShowFullPhoneNumberError(true);
          setPhoneNumberExists(false);
        }
        if (payloadName === "primaryPhoneNumber" && value.length === 10) {
          setShowFullPhoneNumberError(false);
          const response = await http.get(`${field?.apiUrl}+91${value}`);
          if (
            (response?.exists === true &&
            response?.message === Constants.SameDealer) || (response?.exists === true && response.message !== "Other Dealer")
          ) {
            setPhoneNumberExists(true);
          }
        } else {
          setPhoneNumberExists(false);
        }
      }
      const data = {
        attributeId: attributeId,
        name: payloadName,
        value: value,
      };


const currentArray = attributesArrayRef.current;
const index = currentArray.findIndex(attr => attr.attributeId === attributeId);

let updatedArray;

if (index > -1) {
  // Update existing item
  updatedArray = [...currentArray];
  updatedArray[index] = data;
} else {
  // Add new item
  updatedArray = [...currentArray, data];
}

// Update both ref and state
attributesArrayRef.current = updatedArray;
setAttributesArray(updatedArray);
      // attributesArrayRef
      const formSubSegmentPayload = {
        subSegmentId: subsegment?.subSegmentId,
        name: subsegment?.name,
        attributes: attributesArrayRef.current,
      };
      subSegementPayloadRef.current = formSubSegmentPayload;
      setSubSegmentPayload(formSubSegmentPayload);
    }
    
  };
  const updatedArrayForEdit = useRef<{ [key: string]: any }>({});

  const handleChangeFunctionForSelect = (
    e: React.ChangeEvent<HTMLSelectElement>,
    payloadName: string,
    field: any,
    subsegment: any,
    canMultiple: any,
    attributeId: any
  ) => {
    setSpeclizationIsManditory(false);
    try {
      // Parse the JSON value
      const selectedValue = JSON.parse(e.target.value);
      if (selectedValue?.isSpecialization) {
        setSpeclizationIsManditory(true);
        setIsSpecialization(true);
      }
      if(selectedValue?.isBankDetailsManditory){
        setBankDetailsManditory(true);
      }
      if (
        selectedValue?.multipleBranchAccess === true ||
        payloadName === "trainingCertifications"
      ) {
        setMultipleAllowed(true);
      }
      if (canMultiple) {
        handleInputChange(
          subsegment,
          payloadName,
          selectedValue?.name?.id,
          attributeId,
          selectedValue?.name?.name
        );
      } else {
        const data = {
          attributeId: attributeId,
          name: payloadName,
          value: selectedValue?.value,
        };
       
const currentArray = attributesArrayRef.current;
const index = currentArray.findIndex(attr => attr.attributeId === attributeId);

let updatedArray;

if (index > -1) {
  // Update existing item
  updatedArray = [...currentArray];
  updatedArray[index] = data;
} else {
  // Add new item
  updatedArray = [...currentArray, data];
}

attributesArrayRef.current = updatedArray;
setAttributesArray(updatedArray);
      }
    } catch (error) {
      console.error("Error parsing selected value:", error);
    }


    
    const formSubSegmentPayload = {
      subSegmentId: subsegment.subSegmentId,
      name: subsegment.name,
      attributes: attributesArray,
    };
    subSegementPayloadRef.current = formSubSegmentPayload;
    setSubSegmentPayload(formSubSegmentPayload);
  };







const removeDuplicateData = (data: any[], toRemove: [number, any]): any[] => {
  const [, targetObj] = toRemove;

  return data.filter(item => {
    // Remove item if deepEqual
    return JSON.stringify(item) !== JSON.stringify(targetObj);
  });
}



  

  const handleInputChange = async (
    subsegment: any,
    payloadName: string,
    value: any,
    attributeId: any,
    nameInTable: any
  ) => {
    const data = { attributeId, name: payloadName, value: value };
    //------------------>>>the below code is for the table data
    const tableData = { attributeId, name: payloadName, value: subsegment.name=== "Roles" ? nameInTable: value };
    setTablePayload((prevPayload) => ({
      ...prevPayload,
      [payloadName]: nameInTable, // Add/update the key-value pair
    }));

    let isvalidTable = true;


if (subSegmentList.length > 0) {
  if (
    subSegmentList[subSegmentList.length - 1]?.subSegmentId !==
    subsegment?.subSegmentId
  ) {
    const educationalInfoSubSegmentTable = jsonobj[order]?.subSegments?.find(
      (subSegment) => subSegment.name === "Educational Information"
    );
    const workInfoSubsegmentTable = jsonobj[order]?.subSegments?.find(
      (subSegment) => subSegment.name === "Work Experience"
    );  
         if (subsegment.name === "Educational Information" ) {
             const entriesArrayTable = Array.from(latestEducationEntriesRefTable.current.entries());
             const secondLastEntryTable = entriesArrayTable[entriesArrayTable.length - 1];
             if(secondLastEntryTable === undefined || secondLastEntryTable === null) {
                 setEducationalTable(false);
                 setWorkTable(false);
                  payloadIndexForTable.current = payloadIndexForTable.current + 1;
                  attributesRefForTable.current = [];
                    setAttributesArrayForTable([]);
                  
               }else{
                       const errorMessageTable = ValidationForAddMoreEducationalFeilds(educationalInfoSubSegmentTable,secondLastEntryTable[1]);
                      if(errorMessageTable && Object.keys(errorMessageTable).length === 0){
                         setEducationalTable(false);
                           setWorkTable(false);
                                payloadIndexForTable.current = payloadIndexForTable.current + 1;
                             attributesRefForTable.current = [];
                                      setAttributesArrayForTable([]);
                          }else{
                           setEducationalTable(false);
                       setWorkTable(false);
              
                              attributesRefForTable.current = secondLastEntryTable[1].attributes;
                                setEducationalTable(true);
                              const removedataTable = removeDuplicateData(subSegmentRef.current, secondLastEntryTable);
                             subSegmentRefForTable.current = removedataTable;
                            }
                        }
                 }
                        else if(subsegment.name === "Work Experience") {
                              setEducationalTable(false);


                             const entriesArrayTable = Array.from(latestWorkEntriesRefTable.current.entries());
                               const secondLastEntryTable = entriesArrayTable[entriesArrayTable.length - 1];
                                  if(secondLastEntryTable === undefined || secondLastEntryTable === null) {
                                     setWorkTable(false);
                                     setEducationalTable(false);
                                             payloadIndexForTable.current = payloadIndexForTable.current + 1;
                                            attributesRefForTable.current = [];
                                     setAttributesArrayForTable([]);
                  
                  
                                      }else{
                                                const errorMessageTable = ValidationForAddMoreEducationalFeilds(workInfoSubsegmentTable,secondLastEntryTable[1]);
                                              if(errorMessageTable && Object.keys(errorMessageTable).length === 0){
                                                      setWorkTable(false);
                                               setEducationalTable(false);
                                                        payloadIndexForTable.current = payloadIndexForTable.current + 1;
                                                attributesRefForTable.current = [];
                                                    setAttributesArrayForTable([]);
                                                 }else{
                                                      setWorkTable(false);
                                               setEducationalTable(false);
                                                attributesRefForTable.current = secondLastEntryTable[1].attributes;
                                                     setWork(true);
                                                         const removedataTable = removeDuplicateData(subSegmentRef.current, secondLastEntryTable);
                                                           subSegmentRefForTable.current = removedataTable;
                                                      }
                                             }
                           }

              }
       else{
        if(isAddbuttonClicked){
          payloadIndexForTable.current = payloadIndexForTable.current + 1;
          attributesRefForTable.current = [];
            setAttributesArrayForTable([]);
        }
      }
            }
    
    const updatedAttributesForTable = [...attributesRefForTable.current];
    const indexForTable = updatedAttributesForTable.findIndex(
      (attr) => attr?.attributeId === attributeId
    );
    if (indexForTable > -1) {
      updatedAttributesForTable[indexForTable] = tableData; // Update existing attribute
    } else {
      updatedAttributesForTable.push(tableData); // Add new attribute
    }
    // Store updated attributes in ref (no delay)
    attributesRefForTable.current = updatedAttributesForTable;

    // Optionally update state to trigger re-render
    setAttributesArrayForTable(updatedAttributesForTable);

    // Update payloadId and setSubSegmentList immediately
    setPayloadIdforTable(subsegment.subSegmentId);

    const formSubSegmentPayloadForTable = {
      subSegmentId: subsegment.subSegmentId,
      name: subsegment.name,
      attributes: attributesRefForTable.current, // Use updated attributes from ref
    };
    const updatedSubSegmentListForTable = [...subSegmentRefForTable.current];
    

if(payloadIndexForTable.current > -1)
  {
  if(isvalidTable){
    if(isAddbuttonClicked){
      updatedSubSegmentListForTable.push(formSubSegmentPayloadForTable);
    }
            if (
              subSegmentList[subSegmentList.length - 1]?.subSegmentId !==
              subsegment?.subSegmentId && !isAddbuttonClicked
            ){
              updatedSubSegmentListForTable.push(formSubSegmentPayloadForTable);}
            else{
            if(Work){
              updatedSubSegmentListForTable[updatedSubSegmentListForTable.length-1] = formSubSegmentPayloadForTable;
            }if(educational){
              updatedSubSegmentListForTable[updatedSubSegmentListForTable.length-1] = formSubSegmentPayloadForTable;
            }
            else{
              updatedSubSegmentListForTable[updatedSubSegmentListForTable.length-1] = formSubSegmentPayloadForTable;
            }
          }
        }else{
          // updatedSubSegmentListForTable[payloadIndexForTable.current] = formSubSegmentPayloadForTable;
        } 
        // Update payload in list
      } else {
        updatedSubSegmentListForTable.push(formSubSegmentPayloadForTable);// Add new payload// Add new payload
    }
    // Store updated subSegmentList in ref (no delay)
    subSegmentRefForTable.current = updatedSubSegmentListForTable;
    // Optionally update state to trigger re-render
    setSubSegmentListForTable(updatedSubSegmentListForTable);

    //----------------------->> Store updated attributes in ref for the payload(no delay)
    setPayload((prevPayload) => {
      let newPayload: Record<string, any> = {};
      let newDropdownOptions: Record<string, any[]> = {};
  
      if (payloadName === "deptId") {
        setSpeclizationIsManditory(false);
        newPayload = { deptId: value };
        newDropdownOptions = { deptId: dropdownOptionsDynamic?.deptId }; // keep deptId options only
      } else if (payloadName === "groupId") {
        setSpeclizationIsManditory(false);
        newPayload = {
          deptId: prevPayload.deptId,
          groupId: value,
        };
        newDropdownOptions = {
          deptId: dropdownOptionsDynamic?.deptId ,
          groupId: dropdownOptionsDynamic?.groupId,
        };
      } else if (payloadName === "roleId") {
        newPayload = {
          deptId: prevPayload.deptId,
          groupId: prevPayload.groupId,
          roleId: value,
        };
        newDropdownOptions = {
          deptId: dropdownOptionsDynamic?.deptId ,
          groupId: dropdownOptionsDynamic?.groupId ,
          roleId: dropdownOptionsDynamic?.roleId ,
        };
        setSelectedSpecializationList([]);
      } else {
        newPayload = {
          ...prevPayload,
          [payloadName]: value,
        };
        newDropdownOptions = {
          ...dropdownOptionsDynamic,
          // [payloadName]: dropdownOptionsDynamic?.[payloadName] || [],
        };
      }
  
      setDropdownOptionsDynamic(newDropdownOptions);
      return newPayload;
    });

   

let isvalid= true;

    if (subSegmentList.length > 0) {
      if (
        subSegmentList[subSegmentList.length - 1]?.subSegmentId !==
        subsegment?.subSegmentId
      ) {
        const educationalInfoSubSegment = jsonobj[order]?.subSegments?.find(
          (subSegment) => subSegment.name === "Educational Information"
        );
        const workInfoSubsegment = jsonobj[order]?.subSegments?.find(
          (subSegment) => subSegment.name === "Work Experience"
        );  
        if (subsegment.name === "Educational Information" ) {
          const entriesArray = Array.from(latestEducationEntriesRef.current.entries());
            const secondLastEntry = entriesArray[entriesArray.length - 1];
            if(secondLastEntry === undefined || secondLastEntry === null) {
              setEducational(false);
              setWork(false);
              payloadIndex.current = payloadIndex.current + 1;
                      payloadIndexForTable.current = payloadIndexForTable.current + 1;
                        attributesRef.current = [];
                        // return;
            }else{
              const errorMessage = ValidationForAddMoreEducationalFeilds(educationalInfoSubSegment,secondLastEntry[1]);
                if(errorMessage && Object.keys(errorMessage).length === 0){
                  setEducational(false);
                  setWork(false);
                    payloadIndex.current = payloadIndex.current + 1;
                      payloadIndexForTable.current = payloadIndexForTable.current + 1;
                        attributesRef.current = [];
                  }else{
                    setEducational(false);
                    setWork(false);
                      //  payloadIndexForTable.current = payloadIndexForTable.current + 1;
                         attributesRef.current = secondLastEntry[1].attributes;
                         setEducational(true);
                         const removedata = removeDuplicateData(subSegmentRef.current, secondLastEntry);
                         subSegmentRef.current = removedata;
                      }
        }
      }
        else if(subsegment.name === "Work Experience") {
setEducational(false);


          const entriesArray = Array.from(latestWorkEntriesRef.current.entries());
            const secondLastEntry = entriesArray[entriesArray.length - 1];
            if(secondLastEntry === undefined || secondLastEntry === null) {
              setWork(false);
              setEducational(false);
              payloadIndex.current = payloadIndex.current + 1;
                      payloadIndexForTable.current = payloadIndexForTable.current + 1;
                        attributesRef.current = [];
                      
                      
            }else{
              const errorMessage = ValidationForAddMoreEducationalFeilds(workInfoSubsegment,secondLastEntry[1]);
                if(errorMessage && Object.keys(errorMessage).length === 0){
                  setWork(false);
                  setEducational(false);
                    payloadIndex.current = payloadIndex.current + 1;
                      payloadIndexForTable.current = payloadIndexForTable.current + 1;
                        attributesRef.current = [];
                  }else{
                       setWork(false);
                       setEducational(false);
                         attributesRef.current = secondLastEntry[1].attributes;
                         setWork(true);
                         const removedata = removeDuplicateData(subSegmentRef.current, secondLastEntry);
                         subSegmentRef.current = removedata;
                      }
        }
      }
      }
      else{
        if(isAddbuttonClicked){
          payloadIndex.current = payloadIndex.current + 1;
                      payloadIndexForTable.current = payloadIndexForTable.current + 1;
                        attributesRef.current = [];
        }
      }
    }

    // Update the ref immediately

    const updatedAttributes = [...attributesRef.current];
    const index = updatedAttributes.findIndex(
      (attr) => attr?.attributeId === attributeId
    );
    if (index > -1) {
      updatedAttributes[index] = data; // Update existing attribute
    } else {
      updatedAttributes.push(data); // Add new attribute
    }
    // Store updated attributes in ref (no delay)
    attributesRef.current = updatedAttributes;
    // Optionally update state to trigger re-render
    setAttributesArray(updatedAttributes);
    // Update payloadId and setSubSegmentList immediately
    setPayloadId(subsegment.subSegmentId);

    const formSubSegmentPayload = {
      subSegmentId: subsegment.subSegmentId,
      name: subsegment.name,
      attributes: attributesRef.current, // Use updated attributes from ref
    };


    const updatedSubSegmentList = [...subSegmentRef.current];


    if (payloadIndex.current > -1) {
      if(isvalid){
        if(isAddbuttonClicked){
          updatedSubSegmentList.push(formSubSegmentPayload);
        }else{
        // if(payloadName === "Educational Information" ){
          if (
            subSegmentList[subSegmentList.length - 1]?.subSegmentId !==
            subsegment?.subSegmentId && !isAddbuttonClicked
          ){
            updatedSubSegmentList.push(formSubSegmentPayload);}
          else{
          if(Work){
            updatedSubSegmentList[updatedSubSegmentList.length-1] = formSubSegmentPayload;
          }if(educational){
            updatedSubSegmentList[updatedSubSegmentList.length-1] = formSubSegmentPayload;
          }
          else{
            updatedSubSegmentList[updatedSubSegmentList.length-1] = formSubSegmentPayload;
          }
        }
      }
        // }
        // isvalid = false;
      }else{
        // updatedSubSegmentList[payloadIndex.current] = formSubSegmentPayload;
      } 
      // Update payload in list
    } else {
      updatedSubSegmentList.push(formSubSegmentPayload); // Add new payload
    }
    // Store updated subSegmentList in ref (no delay)
    subSegmentRef.current = updatedSubSegmentList;
    // Optionally update state to trigger re-render
    setSubSegmentList(updatedSubSegmentList);
    setIsAddButtonClicked(false);
    validateEducationalDetailsSegment();
    getLastSubsegmentDataForvalidatation();
  };




const [isAddbuttonClicked, setIsAddButtonClicked] = useState(false);
  const handelAddMoreFeilds = (subsegment: any) => {
    if (subsegment.name === "Educational Information") {
      setIsAddButtonClicked(true);
      setShowEducationalTable(false);
    } else if (subsegment.name === "Work Experience") {
      setIsAddButtonClicked(true);
      setShowWorkTable(false);
    } else if(subsegment.name === "Roles"){
      setIsAddButtonClicked(true);
    setShowRolesTable(false);
    attributesRefForTable.current = [];
    setSelectedSpecializationList([]);
    subSegmentRefForTableForvalidation.current=subSegmentRefForTableForvalidation.current+1;
    }
    // const errorMessage = mainValidateFunction(subsegment.subSegmentId);
    // payloadIndexForTable.current = payloadIndexForTable.current + 1;
    // attributesRefForTable.current = [];
    //   setAttributesArrayForTable([]);



    // if (errorMessage && Object.keys(errorMessage).length === 0) {
      payloadIndex.current = payloadIndex.current + 1;
      // setShowEducationalTable(true);
      payloadIndexForTable.current = payloadIndexForTable.current + 1;
      setAttributesArray([]); // Clear attributes for the new field
      setAttributesArrayForTable([]);
      attributesRefForTable.current = [];
      // Update the ref and state to add a new segment
      const newSubsegment = {
        subSegmentId: subsegment.subSegmentId, // Unique ID for new segment
        name: subsegment.name,
        attributes: [], // Empty attributes for the new segment
      };
    // }
  };



  const validatePayloadd = (
    validationJson: Record<string, any>,
    payloadJson: Record<string, any>
  ): Record<string, string> => {
    const errors: Record<string, string> = {};
    for (const [fieldName, fieldRules] of Object.entries(validationJson)) {
      const value = payloadJson[fieldName];

      // Check if the field is required
      if (fieldRules.required) {
        // If value is missing or empty, return the error message
        if (!value || value.trim() === "") {
          errors[fieldName] =
            fieldRules.errorMessage || `${fieldName} is required.`;
          continue;
        }

        // If a pattern is defined, validate the value
        if (fieldRules.pattern && !new RegExp(fieldRules.pattern).test(value)) {
          errors[fieldName] =
            fieldRules.errorMessage || `${fieldName} is invalid.`;
        }
      }
    }
    return errors;
  };

  type OptionType = {
    label: string;
    value: any;
  };

  const handleBranchesDropdownChange = (
    newValue: MultiValue<DropdownOption> | SingleValue<DropdownOption>,
    actionMeta: ActionMeta<DropdownOption>,
    attributeOrder: any,
    subsegment: any,
    payloadName: any
  ) => {
    if (
      payloadName === "trainingCertifications" ||
      payloadName === "branches"
    ) {
      setMultipleAllowed(true);
    }
  
    const updatedValues = Array.isArray(newValue)
      ? newValue.map((option) => option.value)
      : newValue && 'value' in newValue
      ? [newValue.value]
      : [];
  
    setAttributesArrayForBranches((prevArray: any[]) => {
      const existingData = prevArray.find(
        (attr) => attr.attributeId === attributeOrder
      );
  
      const data = {
        attributeId: attributeOrder,
        name: payloadName,
        value: updatedValues,
      };
  
      const attributesBranches = () => {
        if (existingData) {
          return prevArray.map((attr) =>
            attr.attributeId === attributeOrder ? data : attr
          );
        } else {
          return [...prevArray, data];
        }
      };
  
      const attributeBranchesForFormPayload = attributesBranches();
      const formSubSegmentPayload = {
        subSegmentId: subsegment.subSegmentId,
        name: subsegment.name,
        attributes: attributeBranchesForFormPayload,
      };
  
      branchesSubsegementPayloadRef.current = formSubSegmentPayload;
      setSubSegmentPayloadForBranches(formSubSegmentPayload);
      return attributeBranchesForFormPayload;
    });
  };
  

  const handleSpecializationDropdownChange = (
    newValue: MultiValue<OptionType>,
    actionMeta: ActionMeta<OptionType>,
    attributeOrder: any,
    subsegment: any
  ) => {
    if(!speclizationIsManditory){
      multiSelectMaximumValue=1;
    }
    if (newValue) {
      const selectedOptions = newValue as OptionType[];
      let selectedSpecializations = selectedOptions.map(
        (option) => option?.value
        // option?.value
      );
      let selectedSpecializationsId = selectedOptions.map(
        (option) => option?.value?.id
        // option?.value
      );
      let selectedSpecilizationName = selectedOptions.map(
        (option) => option?.value?.name
        // option?.value
      );
      // Check if any single-select options are selected
      const singleSelectOptions = selectedOptions.filter(
        (option) => option?.value?.multipleAllowed === false
      );
      const parsedDeptId =
        typeof jsonForApiCall.deptId === "string"
          ? JSON.parse(jsonForApiCall?.deptId)
          : jsonForApiCall?.deptId;
      if (parsedDeptId?.name?.name === "Sales") {
        if (singleSelectOptions.length > 1) {
          // If more than one single-select option is selected, keep only the last one
          const lastSingleSelectOption =
            singleSelectOptions[singleSelectOptions?.length - 1];

          // Filter out all single-select options except the last one
          selectedSpecializations = selectedSpecializations.filter(
            (option) => option?.multipleAllowed === true
          );
          selectedSpecializations.push(lastSingleSelectOption?.value);
        }
      }
      setSelectedSpecializationList(selectedSpecializations);
      handleInputChange(
        subsegment,
        "specializationIds",
        selectedSpecializationsId,
        attributeOrder,
        selectedSpecilizationName,
      );
    } else {
      setSelectedSpecializationList([]);
      // setErrorMessage("");
    }
  };

  let multiSelectMaximumValue = 2;
  const filterOptions = (option: OptionType) => {
    const selectedOptions = selectedSpecializationList;
    const parsedDeptId =
      typeof jsonForApiCall.deptId === "string"
        ? JSON.parse(jsonForApiCall?.deptId)
        : jsonForApiCall?.deptId;

    const hasSingleSelect = selectedOptions?.some(
      (opt: { multipleAllowed: boolean }) => opt?.multipleAllowed === false
    );
    const hasMultiSelect = selectedOptions?.some(
      (opt: { multipleAllowed: boolean }) => opt?.multipleAllowed === true
    );

    const multiSelectCount = selectedOptions?.filter(
      (opt: { multipleAllowed: boolean }) => opt?.multipleAllowed === true
    ).length;

    //  Disable further multi-selects if the count has reached the max limit
    if (
      hasMultiSelect &&
      multiSelectCount !== undefined &&
      multiSelectCount >= multiSelectMaximumValue
    ) {
      return false;
    }
    if (
      hasSingleSelect &&
      option?.value?.multipleAllowed === false &&
      parsedDeptId?.name?.name === "Sales"
    ) {
      return false; // Prevent multi-select option if single-select is already selected
    }
    if (
      hasSingleSelect &&
      option?.value?.multipleAllowed === true &&
      parsedDeptId?.name?.name === "Sales"
    ) {
      return false; // Prevent multi-select option if single-select is already selected
    }

    if (
      hasMultiSelect &&
      option?.value?.multipleAllowed === false &&
      parsedDeptId?.name?.name === "Sales"
    ) {
      return false; // Prevent single-select option if multi-select is already selected
    }

    return true; // Allow option otherwise
  };

  const handleDropdownClick =
    (apiUrl: any, payloadName: any) => (event: any) => {
      const urlForGettingDropDownOptionsUrl = replaceUrlPlaceholders(
        apiUrl,
        isEditMode ? updatedArrayForEdit.current : payload
      );
      fetchOptions(urlForGettingDropDownOptionsUrl, payloadName);
    };

  const fetchOptions = async (apiUrl: string | undefined, payloadName: any) => {
    try {
      if (!apiUrl) return;
      const response = await http.get(apiUrl);
      if (
        typeof response === "object" &&
        response !== null &&
        payloadName === "specializationIds"
      ) {
        const formattedOptions: OptionType[] = response.specializations.map(
          (spec: any) => ({
            label: spec?.name,
            value: spec, // The entire specialization object as value
          })
        );
        setSpecilizationOptions(formattedOptions);
      } else if (payloadName === "trainingCertifications") {
        const formattedOptions = response.map((certification: any) => ({
          // name: certification?.title, // Use `title` for training certifications
          value: certification, // Store the entire certification object
        }));
        setTrainingOrBranchesOptions(formattedOptions);
      } else if (payloadName === "branches") {
        const formattedOptions = response.map((branch: any) => ({
          // name: branch?.name, // Use `name` for branches
          value: branch, // Store the entire branch object
        }));
        setTrainingOrBranchesOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    }
  };
  const [dropdownOptionsDynamic, setDropdownOptionsDynamic] = useState<
    Record<string, any[]>
  >({});

  const setDropdownOptionsDynamicFun = (payload: any, options: any[]) => {
    setDropdownOptionsDynamic((prevOptions) => ({
      ...prevOptions,
      [payload]: options,
    }));
  };

  

  const replaceUrlPlaceholders = (
    url: string,
    payload: Record<string, any>
  ): string => {
    // Replace placeholders like {deptId} with the value from the payload
    let updatedUrl = url.replace(/\{(\w+)\}/g, (_, key) => {
      console.log("Key:", key, "Value:", payload[key]); // Debugging to see the key and value
      return payload[key] || ""; // Use the value from payload if available, or an empty string
    });

    return updatedUrl;
  };

  const clearAllSpecilizationOptions = () => {
    setSelectedSpecializationList([]);
  };
  const clearAllBranchesOptions = () => {
      setAttributesArrayForBranches([]);
  };

  const clearAllBranchesOptionsForEdit = (
    attributeOrder: any,
    subsegment: any
  ) => {
    if(setEditPayloadjson){
    setEditPayloadjson((prevPayload: any) => {
      const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
  
      const segment = updatedPayload?.formSegments.find((seg: any) =>
        seg.subSegments.some(
          (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
        )
      );
  
      if (segment) {
        const subSegment = segment.subSegments.find(
          (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
        );
  
        if (subSegment) {
          const attribute = subSegment.attributes.find(
            (attr: any) => attr.attributeId === attributeOrder
          );
  
          if (attribute) {
            attribute.value = [];
          }
        }
      }
  
      return updatedPayload;
    });
  }
  };


  const onClickToCreateProfile = async () => {
    const formData = new FormData();

    if (capturedFileImage) formData.append("face", capturedFileImage);
    formData.append(
      "body",
      new Blob([JSON.stringify(payloadForRegistrationJsonApiCall)], {
        type: "application/json",
      })
    );
    await dispatch(registerUserDetailsAsync(formData));
  };

  const onCancelButtonClick = () => {
    setShowCreateProfilePopUp(false);
  };
  const getLastSubsegmentDataForvalidatation = () => {
    subSegmentRef.current?.forEach((entry) => {
      const hasAttributes =
        Array.isArray(entry?.attributes) &&
        entry.attributes.some(
          (attr: { value: string | null }) =>
            attr?.value !== null && attr?.value !== ""
        );
        if( entry?.name === "Educational Information" && !hasAttributes) {
          latestEducationEntriesRef.current.set(entry.subSegmentId, entry);
        }
        if( entry?.name === "Work Experience" && !hasAttributes) {
          latestWorkEntriesRef.current.set(entry.subSegmentId, entry);
        }
      if (entry?.name === "Educational Information" && hasAttributes) {
        latestEducationEntriesRef.current.set(entry.subSegmentId, entry);
      } else if (entry?.name === "Work Experience" && hasAttributes) {
        latestWorkEntriesRef.current.set(entry.subSegmentId, entry);
      }
    });
    subSegmentRefForTable.current?.forEach((entry) => {
      const hasAttributes =
        Array.isArray(entry?.attributes) &&
        entry.attributes.some(
          (attr: { value: string | null }) =>
            attr?.value !== null && attr?.value !== ""
        );
  
      if (entry?.name === "Educational Information" && hasAttributes) {
        latestEducationEntriesRefTable.current.set(entry.subSegmentId, entry);
      } else if (entry?.name === "Work Experience" && hasAttributes) {
        latestWorkEntriesRefTable.current.set(entry.subSegmentId, entry);
      }
    });
  }
  useEffect(() => {
    getLastSubsegmentDataForvalidatation();
  }, [subSegmentRef.current,subSegmentRefForTable.current]);



  
  const latestEducationEntriesRef = useRef<Map<number, any>>(new Map());
const latestWorkEntriesRef = useRef<Map<number, any>>(new Map());
const latestEducationEntriesRefTable = useRef<Map<number, any>>(new Map());
const latestWorkEntriesRefTable = useRef<Map<number, any>>(new Map());
 
// Get the default sub-segments by type
const defaultEducationSubSegments = jsonobj[order]?.subSegments?.filter(
  (seg) =>seg?.name === "Educational Information"
);

const defaultWorkSubSegments = jsonobj[order]?.subSegments?.filter(
  (seg) => seg?.name === "Work Experience"
);
const educationSubSegmentsToValidateRef = useRef<any[]>([]);
const workSubSegmentsToValidateRef = useRef<any[]>([]);

 educationSubSegmentsToValidateRef.current =
  latestEducationEntriesRef.current.size > 0
    ? Array.from(latestEducationEntriesRef.current.values())
    : defaultEducationSubSegments;

 workSubSegmentsToValidateRef.current =
  latestWorkEntriesRef.current.size > 0
    ? Array.from(latestWorkEntriesRef.current.values())
    : defaultWorkSubSegments;


// Final combined list to validate
const latestSubSegmentsRef = useRef<any[]>([]);
const eduSubSegmentsRef = useRef<any[]>([]);
const workSubSegmentsRef = useRef<any[]>([]);

const validateEducationalDetailsSegment = () =>{
  eduSubSegmentsRef.current = educationSubSegmentsToValidateRef.current || [];
  workSubSegmentsRef.current = workSubSegmentsToValidateRef.current || [];
  if (order === 1) {
    
    latestSubSegmentsRef.current = [...eduSubSegmentsRef.current, ...workSubSegmentsRef.current];
  }
}
useEffect(() => {
validateEducationalDetailsSegment();
}, [order,educationSubSegmentsToValidateRef.current, workSubSegmentsToValidateRef.current,subSegmentRef.current, subSegmentRefForTable.current]);

  type ValidationRule = {
    value?: string;
    minLength?: number;
    maxLength?: number;
    errorMessage?: string;
  };

  const validateValue = (
    value: string,
    isRequired: boolean,
    rules: ValidationRule[]
  ): string | null => {
     if (isRequired && (value === null || value === undefined || value === "")) {
        return  "This field is required";
      }
    for (const rule of rules) {
     
      if (rule.value && !new RegExp(rule.value).test(value)) {
        return rule.errorMessage || "Invalid format";
      }
      if (rule.minLength !== undefined && value.length < rule.minLength) {
        return rule.errorMessage || `Minimum length is ${rule.minLength}`;
      }
      if (rule.maxLength !== undefined && value.length > rule.maxLength) {
        return rule.errorMessage || `Maximum length is ${rule.maxLength}`;
      }
    }
    return null; // No errors
  };

  const validateFormDataForMultiple = (jsonObject: any[], payload: any[]) => {
    const errors: Record<string, string> = {};
    jsonObject.forEach((segment) => {
      const payloadSegment = payload.find((p) => {
        return p.subSegmentId === segment?.subSegmentId;
      });
      if (payloadSegment) {
        segment?.attributes?.forEach(
          (attribute: {
            name: any;
            attributeId: any;
            isRequired: any;
            validationRules: {
              regex?: string | undefined;
              minLength?: number | undefined;
              maxLength?: number | undefined;
              errorMessage?: string | undefined;
            }[];
            label: any;
          }) => {
            const userAttribute = payloadSegment.attributes.find(
              (a: { attributeId: any }) =>
                a.attributeId === attribute.attributeId
            );
            
            if (attribute.isRequired ) {
              const errorMessage = validateValue( 
                userAttribute?.value,
                attribute?.isRequired,
                attribute?.validationRules
              );
              if (errorMessage) {
                errors[`${attribute.name}`] = errorMessage;
              }
            }
          }
        );
      }
    });
    if(errors){
      setErrors(errors);
    } 
    return errors;
  };

  const openModal = () => {
    setShowPopUp(true);
  };

  const closeModal = () => {
    setShowPopUp(false);
    dispatch(resetRegisterUserStatus());
    dispatch(resetUserRegistrationNewpayload());
    navigate(`/dashboard`);
  };
  const [selectedFile, setSelectedFile] = useState<any>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  // come back hereeeeeeee
  const handelChangeForEditFlow = (
    e: React.ChangeEvent<HTMLInputElement>,
    payloadName: string,
    field: any,
    subsegment: any,
    canMultiple: any,
    attributeId: any
  ) => {
    const newValue = e.target.value;
    const orderForPayload =
      addmoreEducationOrder || addmoreWorkOrder || addmoreRolesOrder;
    if (
      (showEducationTableInEditFlow === false ||
      showWorkTableInEditFlow === false ||
      showRolesTableInEditFlow === false) && !isWorkDetailsNullRef
    ) {
      setJsonForEdit((prevPayload: any) => {
        const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
        const segment = updatedPayload?.formSegments[orderForPayload];
        const subSegement =
          segment?.subSegments[segment?.subSegments?.length - 1];
        const attributeToUpdate = subSegement?.attributes.find(
          (attr: any) => attr?.attributeId === attributeId
        );
        if (attributeToUpdate) {
          attributeToUpdate.value = newValue;
        } else {
          return prevPayload;
        }

        if (setEditPayloadjson) {
          setEditPayloadjson((prevPayload: any) => {
            return updatedPayload;
          });
        }
        const value =
          updatedPayload.formSegments[orderForPayload].subSegments[
            segment?.subSegments.length - 1
          ];
        setJsonForEditFlow({
          segmentId: updatedPayload.formSegments[orderForPayload].segmentId,
          name: updatedPayload.formSegments[orderForPayload].name,
          description: updatedPayload.formSegments[orderForPayload].description,
          segmentOrder:
            updatedPayload.formSegments[orderForPayload].segmentOrder,
          subSegments: [value],
        });
        return updatedPayload;
      });
    } else {
      if (
        subsegment?.name === "Educational Information" ||
        subsegment?.name === "Work Experience" || isWorkDetailsNullRef
      ) {
        
        setJsonForEdit((prevPayload: any) => {
          const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
          const segments = updatedPayload?.formSegments[1]?.subSegments?.filter(
            (segment: any) => segment?.name === subsegment?.name
          );
          const subSegment = segments[indexOfValueToBeModified];
          // if (segment) {
          //   const subSegment = segment?.subSegments.find((sub: any) => sub?.subSegmentId === subsegment?.subSegmentId);
          if (subSegment) {
            const attribute = subSegment?.attributes.find(
              (attr: any) => attr?.attributeId === attributeId
            );
            if (attribute) {
              attribute.value = newValue;
            }
            // }
          }
          if (setEditPayloadjson) {
            setEditPayloadjson((prevPayload: any) => {
              return updatedPayload;
            });
          }
          return updatedPayload;
        });
      } else {
        if (setEditPayloadjson) {
          setEditPayloadjson((prevPayload: any) => {
            //     // return prevPayload;
            const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
            const segment = updatedPayload?.formSegments?.find((seg: any) =>
              seg.subSegments.some(
                (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
              )
            );
            if (segment) {
              const subSegment = segment?.subSegments.find(
                (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
              );
              if (subSegment) {
                const attribute = subSegment?.attributes.find(
                  (attr: any) => attr?.attributeId === attributeId
                );
                if (attribute) {
                  attribute.value = newValue;
                }
              }
            }
            // Dispatch the updated JSON to Redux
            // dispatch(updateUserData(updatedPayload));

            return updatedPayload;
          });
        }
      }
    }
  };

  const handelChangeForEditFlowSelect = (
    e: React.ChangeEvent<HTMLSelectElement>,
    payloadName: string,
    field: any,
    subsegment: any,
    canMultiple: any,
    attributeId: any
  ) => {
    if(isEditMode){
      setSpeclizationIsManditory(false);
if(payloadName === "roleId"){
      setIsSpecilizationManditory(false);
    }
  }else{
    setIsSpecilizationManditory(false);
  }
    const parsedValue = JSON.parse(e.target.value);
    const newValue = (payloadName === "gender" || payloadName === "maritialStatus") ? parsedValue.value : parsedValue;
    if(newValue?.isSpecialization){
      setSpeclizationIsManditory(true);
      setIsSpecialization(true);
      setIsSpecilizationManditory(true);
    }
    const orderForPayload =
      addmoreEducationOrder || addmoreWorkOrder || addmoreRolesOrder;
    if (
      showEducationTableInEditFlow === false ||
      showWorkTableInEditFlow === false ||
      showRolesTableInEditFlow === false
    ) {
      setJsonForEdit((prevPayload: any) => {
        const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
        const segment = updatedPayload?.formSegments[orderForPayload];
        const subSegement =
          segment?.subSegments[segment?.subSegments.length - 1];
        const attributeToUpdate = subSegement?.attributes.find(
          (attr: any) => attr.attributeId === attributeId
        );
        if (attributeToUpdate) {
          attributeToUpdate.value =
            subsegment.name === "Roles" ? newValue?.name?.id : newValue;
        } else {
          return prevPayload;
        }

        if (setEditPayloadjson) {
          setEditPayloadjson((prevPayload: any) => {
            return updatedPayload;
          });
        }
        const value =
          updatedPayload.formSegments[orderForPayload].subSegments[
            segment?.subSegments.length - 1
          ];
        setJsonForEditFlow({
          segmentId: updatedPayload.formSegments[orderForPayload].segmentId,
          name: updatedPayload.formSegments[orderForPayload].name,
          description: updatedPayload.formSegments[orderForPayload].description,
          segmentOrder:
            updatedPayload.formSegments[orderForPayload].segmentOrder,
          subSegments: [value],
        });
        if (payloadName === "deptId") {
          setSpeclizationIsManditory(false);
          updatedArrayForEdit.current = {
            deptId: newValue?.name?.id,
          };
        
          setDropdownOptionsDynamic({
            deptId: dropdownOptionsDynamic?.deptId,
          });
        
        } else if (payloadName === "groupId") {
          setSpeclizationIsManditory(false);
          updatedArrayForEdit.current = {
            deptId: updatedArrayForEdit.current.deptId,
            groupId: newValue?.name?.id,
          };
        
          setDropdownOptionsDynamic({
            deptId: dropdownOptionsDynamic?.deptId,
            groupId: dropdownOptionsDynamic?.groupId,
          });
        
        } else if (payloadName === "roleId") {
          // setSpeclizationIsManditory(false);
          updatedArrayForEdit.current = {
            deptId: updatedArrayForEdit.current.deptId,
            groupId: updatedArrayForEdit.current.groupId,
            roleId: newValue?.name?.id,
          };
        
          setDropdownOptionsDynamic({
            deptId: dropdownOptionsDynamic?.deptId,
            groupId: dropdownOptionsDynamic?.groupId,
            roleId: dropdownOptionsDynamic?.roleId,
          });
        
        } else {
          updatedArrayForEdit.current = {
            ...updatedArrayForEdit.current,
            [payloadName]: newValue?.name?.id,
          };
        
          setDropdownOptionsDynamic({
            ...dropdownOptionsDynamic,
          });
        }
        return updatedPayload;
      });
    } else {
      if (
        subsegment?.name === "Educational Information" ||
        subsegment?.name === "Work Experience"
      ) {
        setJsonForEdit((prevPayload: any) => {
          const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
          const segments = updatedPayload?.formSegments[1]?.subSegments?.filter(
            (segment: any) => segment.name === subsegment.name
          );
          const subSegment = segments[indexOfValueToBeModified];
          if (subSegment) {
            const attribute = subSegment?.attributes.find(
              (attr: any) => attr?.attributeId === attributeId
            );
            if (attribute) {
              attribute.value = newValue;
            }
          }
          if (setEditPayloadjson) {
            setEditPayloadjson((prevPayload: any) => {
              return updatedPayload;
            });
          }
          return updatedPayload;
        });
      } else {
        if (setEditPayloadjson) {
          setEditPayloadjson((prevPayload: any) => {
            const updatedPayload = JSON.parse(JSON.stringify(prevPayload));

            const segment = updatedPayload?.formSegments.find((seg: any) =>
              seg.subSegments.some(
                (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
              )
            );

            if (segment) {
              const subSegment = segment?.subSegments.find(
                (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
              );
              if (subSegment) {
                const attribute = subSegment?.attributes.find(
                  (attr: any) => attr.attributeId === attributeId
                );
                if (attribute) {
                  attribute.value = newValue;
                }
              }
            }

            return updatedPayload;
          });
        }
      }
    }
  };
const isAddbuttonClickedRef = useRef(false);

const ValidationForAddMoreEducationalFeilds = (schema: any, filledData: any) => {
  const errors: Record<string, string> = {};
  // Create a map of filled attributes for quick lookup
  const filledAttributeMap = new Map(
    filledData?.attributes?.map((attr: any) => [attr?.name, attr?.value])
  );

  // Loop over the schema's attributes
  schema.attributes.forEach((schemaAttr: any) => {
    const { name, isRequired } = schemaAttr;

    if (isRequired) {
      const value = filledAttributeMap.get(name);

      if (value === null || value === undefined || value === '') {
        errors[name] = `${schemaAttr.label || name} is required`;
      }
    }
  });

  return errors;

}
 const handelAddFeilds = (subsegment: any) => {
    const educationalInfoSubSegment = jsonobj[order]?.subSegments?.find(
      (subSegment) => subSegment.name === "Educational Information"
    );
    const workInfoSubsegment = jsonobj[order]?.subSegments?.find(
      (subSegment) => subSegment.name === "Work Experience"
    );  
   
    if (subsegment.name === "Educational Information") {
        let validateEducationalDetails ;
       
        if(subSegmentRef.current.length > 0){
         
        subSegmentRef.current?.forEach((entry) => {
          const hasAttributes =
            Array.isArray(entry?.attributes) &&
            entry.attributes.some(
              (attr: { value: string | null }) =>
                attr?.value !== null && attr?.value !== ""
            );
            if (hasAttributes) {
              const validateEducationalDetails = Array.from(latestEducationEntriesRef.current);
              const educationalInfo = validateEducationalDetails[0][1];
              const errorMessage = ValidationForAddMoreEducationalFeilds(educationalInfoSubSegment,educationalInfo);
              setErrors?.(errorMessage);
              if(Object.keys(errorMessage).length === 0){
                setIsErrors?.(false);
                setShowEducationalTable(true);
              }
            }
          });
          }else{
              const emptyFilledData = {
                subSegmentId: educationalInfoSubSegment?.subSegmentId,
                name: educationalInfoSubSegment?.name,
                ttributes: educationalInfoSubSegment?.attributes.map(attr => ({
                  attributeId: attr.attributeId,
                  name: attr.name,
                  value: null // or "", both considered empty
                }))
              };
              const errorMessage = ValidationForAddMoreEducationalFeilds(educationalInfoSubSegment, emptyFilledData);
          
            
              // Show the errors
              setErrors?.(errorMessage);
              setIsErrors?.(true);
   
          }
    } else if (subsegment.name === "Work Experience") {
      

      let validateWorkDetails ;
       
      if(subSegmentRef.current.length > 0){
       
      subSegmentRef.current?.forEach((entry) => {
        const hasAttributes =
          Array.isArray(entry?.attributes) &&
          entry.attributes.some(
            (attr: { value: string | null }) =>
              attr?.value !== null && attr?.value !== ""
          );
          if (hasAttributes) {
            const validateWorkDetails = Array.from(latestWorkEntriesRef.current);
            const WorkInfo = validateWorkDetails[0][1];
            const errorMessage = ValidationForAddMoreEducationalFeilds(workInfoSubsegment,WorkInfo);
            setErrors?.(errorMessage);
            if(Object.keys(errorMessage).length === 0){
              setIsErrors?.(false);
              setShowWorkTable(true);
            }
          }
        });
        }else{

            const emptyFilledData = {
              subSegmentId: workInfoSubsegment?.subSegmentId,
              name: workInfoSubsegment?.name,
              ttributes: workInfoSubsegment?.attributes.map(attr => ({
                attributeId: attr.attributeId,
                name: attr.name,
                value: null // or "", both considered empty
              }))
            };
            const errorMessage = ValidationForAddMoreEducationalFeilds(workInfoSubsegment, emptyFilledData);
          
            // Show the errors
            setErrors?.(errorMessage);
            setIsErrors?.(true);
 
        }

    }else if(subsegment.name === "Roles"){
      const attributes = subSegmentRefForTable.current?.[subSegmentRefForTable.current.length - 1]?.attributes || [];
      const attributeMap = attributes.reduce((acc: any, attr: any) => {
        acc[attr.name] = attr.value;
        return acc;
      }, {});

      const specializationAttr = subSegmentRef.current.flatMap(item => item.attributes).find(attr => attr.name === "specializationIds");
      const newErrors: Record<string, string> = {};
      if (!attributeMap["deptId"]) {
        newErrors["deptId"] = "Department is required";
      }
      if (!attributeMap["groupId"]) {
        newErrors["groupId"] = "Group is required";
      }
      if (!attributeMap["roleId"]) {
        newErrors["roleId"] = "Role is required";
      }
      if(speclizationIsManditory){
        
          const isEmpty =
          !Array.isArray(specializationAttr?.value) || specializationAttr?.value?.length === 0;
          if (isEmpty) {
            newErrors["specializationIds"] = "Specialization is required";
          }
        
      }
      if(subSegmentRefForTableForvalidation.current !== subSegmentRefForTable.current.length)
        {
          newErrors["deptId"] = "Department is required";
          newErrors["groupId"] = "Group is required";
          newErrors["roleId"] = "Role is required";

        }
       
      
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({}); // clear previous errors if any
        setShowRolesTable(true);
      }
    }
  };
  
  const handleBranchesDropdownChangeForEdit = (
    newValue: MultiValue<DropdownOption> | SingleValue<DropdownOption>,
    actionMeta: ActionMeta<DropdownOption>,
    attributeOrder: any,
    subsegment: any,
    payloadName: any,
    isRequired:any,
  ) => {
    if(isRequired){
      setIsBranchesManditory(true);
    }
    if (payloadName === "trainingCertifications" || payloadName === "branches") {
      setMultipleAllowed(true);
    }
  if(setEditPayloadjson){
    setEditPayloadjson((prevPayload: any) => {
      const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
  
      const segment = updatedPayload?.formSegments.find((seg: any) =>
        seg.subSegments.some(
          (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
        )
      );
  
      if (segment) {
        const subSegment = segment.subSegments.find(
          (sub: any) => sub?.subSegmentId === subsegment?.subSegmentId
        );
  
        if (subSegment) {
          const attribute = subSegment.attributes.find(
            (attr: any) => attr.attributeId === attributeOrder
          );
  
          if (attribute) {
            let normalizedNewValue: any[] = [];
  
            // ✅ Handle multi-select (array)
            if (Array.isArray(newValue)) {
              normalizedNewValue = newValue.map((item) => item.value);
            }
            // ✅ Handle single-select (object or null)
            else if (newValue && typeof newValue === "object" && "value" in newValue) {
              normalizedNewValue = [newValue.value];
            }
  
            // ✅ Always replace the attribute value with latest selected items
            attribute.value = normalizedNewValue;
          }
        }
      }
  
      return updatedPayload;
    });
  }
  };
  
  
  
  const handleSpecilizationDropdownChangeForEdit = (
    newValue: MultiValue<OptionType>,
    actionMeta: ActionMeta<OptionType>,
    attributeOrder: any,
    subsegment: any
  ) => {
    if (newValue) {
      const selectedOptions = newValue as OptionType[];
      let selectedSpecializations = selectedOptions.map(
        (option) => option?.value
      );
      let selectedSpecializationsId = selectedOptions.map(
        (option) => option?.value?.id
      );
      // Check if any single-select options are selected
      const singleSelectOptions = selectedOptions.filter(
        (option) => option?.value?.multipleAllowed === false
      );
      const parsedDeptId =
        typeof jsonForApiCall.deptId === "string"
          ? JSON.parse(jsonForApiCall?.deptId)
          : jsonForApiCall?.deptId;
      if (parsedDeptId?.name?.name === "Sales") {
        if (singleSelectOptions.length > 1) {
          // If more than one single-select option is selected, keep only the last one
          const lastSingleSelectOption =
            singleSelectOptions[singleSelectOptions?.length - 1];

          // Filter out all single-select options except the last one
          selectedSpecializations = selectedSpecializations.filter(
            (option) => option?.multipleAllowed === true
          );
          selectedSpecializations.push(lastSingleSelectOption?.value);
        }
      }
      setSelectedSpecializationList(selectedSpecializations);

      const orderForPayload = addmoreRolesOrder;
      if (showRolesTableInEditFlow === false) {
        setJsonForEdit((prevPayload: any) => {
          const updatedPayload = JSON.parse(JSON.stringify(prevPayload));
          const segment = updatedPayload?.formSegments[orderForPayload];
          const subSegement =
            segment?.subSegments[segment?.subSegments.length - 1];

          const attributeToUpdate = subSegement?.attributes.find(
            (attr: any) => attr.name === "specializationIds"
          );
          if (attributeToUpdate) {
            attributeToUpdate.value = selectedSpecializationsId;
          } else {
            return prevPayload;
          }

          if (setEditPayloadjson) {
            setEditPayloadjson((prevPayload: any) => {
              return updatedPayload;
            });
          }
          const value =
            updatedPayload.formSegments[orderForPayload].subSegments[
              segment?.subSegments.length - 1
            ];
          setJsonForEditFlow({
            segmentId: updatedPayload.formSegments[orderForPayload].segmentId,
            name: updatedPayload.formSegments[orderForPayload].name,
            description:
              updatedPayload.formSegments[orderForPayload].description,
            segmentOrder:
              updatedPayload.formSegments[orderForPayload].segmentOrder,
            subSegments: [value],
          });
          updatedArrayForEdit.current = {
            ...updatedArrayForEdit.current, // Keep existing key-value pairs
            ["specializationIds"]: selectedSpecializationsId, // Add new key-value pair or update existing one
          };
          return updatedPayload;
        });
      } else {
        setSelectedSpecializationList([]);
      }
    }
  };
  return (
    <div className="dynamic-form ml-[4vw] md:ml-[2.7vw] mr-[4vw] md:mr-[2.7vw] pb-14">
      {jsonobj && jsonobj?.length > 0 && (
        <div className="segment">
          {jsonobj &&
            jsonobj[order]?.subSegments?.map(
              (subsegment: SubSegment, subsegmentIndex: number) => (
                <div
                  key={subsegmentIndex}
                  className="flex justify-between items-center"
                >
                  {!isEditMode && (
                    <div>
                      {subsegmentIndex === 0 && (
                        <div className="flex">
                          {subsegmentIcons[subsegment?.name] && (
                            <span className="ml-2">
                              {React.createElement(
                                subsegmentIcons[subsegment?.name]
                              )}
                            </span>
                          )}
                          <h4 className="subsegment-title pl-2 font-poppins font-semibold">
                            {subsegment?.name}
                          </h4>
                        </div>
                      )}
                    </div>
                  )}
                  {
                  subsegment?.name === "Roles" &&
                  !isEditMode ? (!showRolesTable ?
                    <div>
                      <Button
                        handleClick={() => {
                          handelAddFeilds(subsegment);
                        }}
                        buttonText={`+ Add `}
                        className={AddEducationButtonStyle}
                      />
                    </div>: <div><Button
                        handleClick={() => {
                          handelAddMoreFeilds(subsegment);
                        }}
                        buttonText={`+ Add more`}
                        className={AddEducationButtonStyle}
                      /></div>
                  ) : (
                    <div>
                      {subsegment?.canMultiple &&
                        subsegmentIndex === 0 &&
                        !isEditMode && (
                          <Button
                            handleClick={() => {
                              if (
                                (subsegment?.name ===
                                  "Educational Information" &&
                                  showEducationaltable) ||
                                (subsegment?.name === "Work Experience" &&
                                  showWorktable)
                              ) {
                                handelAddMoreFeilds(subsegment);
                              } else {
                                handelAddFeilds(subsegment);
                              }
                            }}
                            buttonText={
                              (subsegment?.name === "Educational Information" &&
                                showEducationaltable) ||
                              (subsegment?.name === "Work Experience" &&
                                showWorktable)
                                ? `+ Add`
                                : `+ Add more`
                            }
                            className={AddEducationButtonStyle}
                          />
                        )}
                    </div>
                  )}
                </div>
              )
            )}
          {hasFace && (
            <div className="flex flex-col md:flex-row mt-5">
              <div className="flex">
                <div className="flex flex-col">
                  <div
                    data-testid="open-camera"
                    className="mr-6 h-[100px] w-[100px] bg-selectedMenu rounded-lg flex justify-center items-center"
                    onClick={() => {
                      if (verifyFaceRecognitionAsyncStatus != STATUS.LOADING) {
                        startCamera();
                      }
                    }}
                  >
                    {isFaceExists.formData?.face ? (
                      <div>
                        {verifyFaceRecognitionAsyncStatus === STATUS.LOADING ? (
                          <Loader />
                        ) : (
                          <img src={capturedImage} alt="Captured" />
                        )}
                      </div>
                    ) : (
                      <div>
                        <CameraIcon />
                      </div>
                    )}
                  </div>
                  {cameraErrorstatus === "failed" ? (
                    <div className="text-redColor text-xs pt-1 ">
                      {cameraError}
                    </div>
                  ) : (
                    faceErrorMessage &&
                    capturedFileImage === undefined && (
                      <div className="text-redColor text-xs pt-1 ">
                        {faceErrorMessage}
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="mb-2">
                <div className="flex">
                <div className="capture">{OnboardConstants.CapturePhoto}</div><div className="text-redColor quickLinksTitle pl-1">*</div>
                </div>
                <div className="body1 mt-2 ">{OnboardConstants.CaptureDesc}</div>
              </div>
            </div>
          )}
          <h3 className="segment-title"></h3>
          {showRolesTable ? (
            <div>
              <RolesAndPermissionTable
                userDetail={subSegmentRefForTable.current}
                selectedSpecializationList={selectedSpecializationList}
                handleDeleteButtonChange={() => {}}
                        handleEditRolesInformation={() => {}}
                        rolesDetailsIndex={0}
                        editModeForRolesDetails={false}
                        order={order}
                        addMoreRolesInfo={false}
                        setEditPayloadjson={() => {}}
                        jsonForEditData={undefined}
              />
            </div>
          ) : (
            <div>
              {jsonobj[order]?.subSegments?.map(
                (subsegment: SubSegment, subsegmentIndex: number) => (
                  <div key={subsegmentIndex} className="subsegment">
                    <div className="flex justify-between items-center ">
                      {subsegmentIndex !== 0 && (
                        <div className="flex">
                          {subsegmentIcons[subsegment?.name] && (
                            <span className="ml-2 mt-8">
                              {React.createElement(
                                subsegmentIcons[subsegment?.name]
                              )}
                            </span>
                          )}
                          <h4 className="subsegment-title pl-2 mt-8 font-poppins font-semibold">
                            {subsegment?.name}
                          </h4>
                        </div>
                      )}
                      {subsegment?.canMultiple &&
                        subsegmentIndex !== 0 &&
                        !isEditMode && (
                          <div className="mt-8">
                            <Button
                              handleClick={() => {
                                if (
                                  (subsegment.name ===
                                    "Educational Information" &&
                                    showEducationaltable) ||
                                  (subsegment.name === "Work Experience" &&
                                    showWorktable)
                                ) {
                                  handelAddMoreFeilds(subsegment);
                                } else {
                                  handelAddFeilds(subsegment);
                                }
                              }}
                              buttonText={
                                (subsegment.name ===
                                  "Educational Information" &&
                                  showEducationaltable) ||
                                (subsegment.name === "Work Experience" &&
                                  showWorktable)
                                  ? `+ Add`
                                  : `+ Add`
                              }
                              className={AddEducationButtonStyle}
                            />
                          </div>
                        )}
                    </div>
                    {showEducationaltable &&
                    subsegment?.name === "Educational Information" ? (
                      <EducationalDetailsTable
                        userDetail={subSegmentRefForTable.current}
                        handleEditEducationalInformation={() => {}}
                        educationalDetailsIndex={0}
                        editModeForEducationalDetails={false}
                        order={order}
                        addMoreEducationalInfo={false}
                        setEditPayloadjson={() => {}}
                        jsonForEditData={undefined}
                      />
                    ) : showWorktable &&
                      subsegment?.name === "Work Experience" ? (
                      <WorkExperienceTable
                        userDetail={subSegmentRefForTable.current}
                        handleEditWorkInformation={undefined}
                        editModeForWorkDetails={undefined}
                        workDetailsIndex={undefined}
                        order={undefined}
                        addMoreWorkInfo={undefined}
                        setEditPayloadjson={() => {}}
                        jsonForEditData={undefined}
                      />
                    ) : (
                      <div>
                        <div className="fields grid grid-cols-1 md:grid-cols-3 gap-4">
                          {subsegment?.attributes
                            .filter((field: any) => {
                              return field?.inputType !== "MultipartFile";
                            })
                            .map((field: any, fieldIndex) => {
                              const isError = errors && errors[field?.name];
                              const options =
                                typeof field.options === "string"
                                  ? field?.options
                                      .split(",")
                                      .map((option: any) => ({
                                        value: option,
                                        label: option,
                                      }))
                                  : field.options || [];
                            
                              return (
                                <div key={field?.name} className="field">
                                  {field?.inputType === "select-multiple" &&
                                  field?.name === "specializationIds" ? (
                                    // Render SelectDropDown if the inputType is select-multiple
                                    isSpecialization && (
                                      <div className={"grow"}>
                                        <div
                                          className={`relative mt-6  border   ${
                                            isError
                                              ? "border-redColor"
                                              : "border-sideMenuHelpBox"
                                          } rounded-xl focus-within:border-blue-500  min-h-[55px]`}
                                        >
                                          <label
                                            className={`absolute top-0 left-2 bg-white px-2 labelText ${
                                              isError && "text-redColor"
                                            }`}
                                          >
                                            <div className="flex">   {field?.label} {speclizationIsManditory && <div className="text-redColor quickLinksTitle pl-1">*</div> }</div>
                                           
                                          </label>
                                          <SelectDropDown
                                            components={{
                                              MenuList: (props) => (
                                                <CustomMenuList
                                                  {...props}
                                                  clearAllOptions={
                                                    clearAllSpecilizationOptions
                                                  }
                                                />
                                              ),
                                              Option:
                                                MultiSelectDropDownOptionsComponent,
                                              DropdownIndicator:
                                                CustomDropdownIcon,
                                            }}
                                            onFocus={handleDropdownClick(
                                              field?.apiUrl,
                                              field?.name
                                            )}
                                            onChange={(
                                              selectedOptions,
                                              actionMeta
                                            ) => {
                                              const normalizedOptions = Array.isArray(selectedOptions)
                                                ? selectedOptions
                                                : selectedOptions
                                                ? [selectedOptions]
                                                : [];
                                            
                                              if (!isEditMode) {
                                                handleSpecializationDropdownChange(
                                                  normalizedOptions,
                                                  actionMeta,
                                                  field?.attributeId,
                                                  subsegment
                                                );
                                              } else {
                                                handleSpecilizationDropdownChangeForEdit(
                                                  normalizedOptions,
                                                  actionMeta,
                                                  field?.attributeId,
                                                  subsegment
                                                );
                                              }
                                            }}
                                            
                                            value={
                                              selectedSpecializationList?.map(
                                                (spec) => ({
                                                  label: spec?.name,
                                                  value: spec,
                                                })
                                              ) ?? []
                                            }
                                            isMulti
                                            placeholder={
                                              PlaceHolderText.specialization
                                            }
                                            options={specilizationOptions}
                                            isOptionDisabled={(option) => {
                                              if (!speclizationIsManditory) {
                                                // If only one value is allowed and one is already selected
                                                return (
                                                  selectedSpecializationList &&
                                                  selectedSpecializationList.length > 0 &&
                                                  !selectedSpecializationList.some(
                                                    (selected) => selected.id === option.value.id
                                                  )
                                                ) || false; // Ensure it returns a boolean
                                              }
                                            
                                              // Use your existing filter logic when multiple are allowed
                                              return filterOptions(option as OptionType) ? false : true; // Ensure it returns a boolean
                                            }}
                                            
                                            className="w-full pt-2"
                                            hideSelectedOptions={false}
                                            isClearable={false}
                                            styles={{
                                              control: (provided) => ({
                                                ...provided,
                                                boxShadow: "none",
                                                border: "none",
                                                minHeight: "40px",
                                              }),

                                              indicatorSeparator: () => ({
                                                display: "none",
                                              }),
                                              valueContainer: (provided) => ({
                                                ...provided,
                                                fontFamily: "Nunito Sans",
                                                fontSize: "16px",
                                                fontWeight: 400,
                                                textAlign: "left",
                                                outline: "none",
                                                color: "#404040",
                                              }),
                                              option: (provided) => ({
                                                ...provided,
                                                backgroundColor: "white",
                                              }),
                                              placeholder: (provided) => ({
                                                ...provided,
                                                fontFamily: "Nunito Sans",
                                                fontSize: "16px",
                                                fontWeight: 400,
                                                textAlign: "left",
                                                outline: "none",
                                                width: "100%",
                                                color: "#B3B3B3",
                                              }),
                                            }}
                                          />
                                        </div>
                                      </div>
                                    )
                                  ) : field.inputType === "select-multiple" ||
                                    field.name === "branches" ? (
                                    <div className={"grow"}>
                                      <div
                                        className={`relative mt-6  border   ${
                                          isError
                                            ? "border-redColor"
                                            : "border-sideMenuHelpBox"
                                        } rounded-xl focus-within:border-blue-500  min-h-[55px]`}
                                      >
                                        <label
                                          className={`absolute top-0 left-2 bg-white px-2 labelText ${
                                            isError && "text-redColor"
                                          }`}
                                        >
                                          <div className="flex">  {field?.label} {field?.isRequired && <div className="text-redColor quickLinksTitle pl-1">*</div> }</div>
                                          
                                        </label>
                                        <SelectDropDown
                                          components={{
                                            MenuList: (props) => (
                                              <CustomMenuList
                                                {...props}
                                                clearAllOptions={() =>
                                                  isEditMode ? clearAllBranchesOptionsForEdit(field?.attributeId, subsegment):
                                                  clearAllBranchesOptions
                                                }
                                              />
                                            ),
                                            Option:
                                              MultiSelectDropDownOptionsComponent, // ✅ Pass custom component
                                            DropdownIndicator:
                                              CustomDropdownIcon,
                                          }}
                                          onFocus={handleDropdownClick(
                                            field?.apiUrl,
                                            field?.name
                                          )}
                                          onChange={(
                                            selectedOptions:
                                              | MultiValue<DropdownOption>
                                              | SingleValue<DropdownOption>, // Supports both multi & single select
                                            actionMeta: ActionMeta<DropdownOption>
                                          ) => {
                                            !isEditMode
                                              ? handleBranchesDropdownChange(
                                                  selectedOptions,
                                                  actionMeta,
                                                  field?.attributeId,
                                                  subsegment,
                                                  field?.name
                                                )
                                              : handleBranchesDropdownChangeForEdit(
                                                  selectedOptions,
                                                  actionMeta,
                                                  field?.attributeId,
                                                  subsegment,
                                                  field?.name,
                                                  field?.isRequired
                                                );
                                          }}
                                          // value={null}
                                          value={
                                            isEditMode
                                              ? (Array.isArray(field?.value)
                                                  ? field?.value
                                                  : [field?.value]
                                                )?.map((value: any) => ({
                                                  label:
                                                    value?.title || value?.name,
                                                  value: value,
                                                }))
                                              : attributesArrayForBranches.flatMap(
                                                  (spec: { value: any }) =>
                                                    spec.value.map(
                                                      (value: any) => ({
                                                        label:
                                                          value.title ||
                                                          value.name, // Ensure label is a string
                                                        value: value,
                                                      })
                                                    )
                                                ) || []
                                          }
                                          isMulti={multipleAllowed}
                                          // isMulti
                                          placeholder={`Enter ${field.label}`}
                                          options={trainingOrBranchesOptions?.map(
                                            (option) => ({
                                              label:
                                                option?.value?.name ||
                                                option?.value?.title ||
                                                "", // Ensure label is a string
                                              value: option?.value, // `value` is the entire object
                                            })
                                          )}
                                          className="w-full pt-2"
                                          hideSelectedOptions={false}
                                          isClearable={false}
                                          styles={{
                                            control: (provided) => ({
                                              ...provided,
                                              boxShadow: "none",
                                              border: "none",
                                              minHeight: "40px",
                                            }),

                                            indicatorSeparator: () => ({
                                              display: "none",
                                            }),
                                            valueContainer: (provided) => ({
                                              ...provided,
                                              fontFamily: "Nunito Sans",
                                              fontSize: "16px",
                                              fontWeight: 400,
                                              textAlign: "left",
                                              outline: "none",
                                              color: "#404040",
                                            }),
                                            option: (provided) => ({
                                              ...provided,
                                              backgroundColor: "white",
                                            }),
                                            placeholder: (provided) => ({
                                              ...provided,
                                              fontFamily: "Nunito Sans",
                                              fontSize: "16px",
                                              fontWeight: 400,
                                              textAlign: "left",
                                              outline: "none",
                                              width: "100%",
                                              color: "#B3B3B3",
                                            }),
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : field.inputType === "select" ? (
                                    // Render SelectDropdown if the inputType is select
                                    <SelectDropdown
                                      name={field.label}
                                      label={field.label}
                                      options={options}
                                      handleOnChange={(e) =>
                                        !isEditMode
                                          ? handleChangeFunctionForSelect(
                                              e,
                                              field.name,
                                              field,
                                              subsegment,
                                              subsegment.canMultiple,
                                              field.attributeId
                                            )
                                          : handelChangeForEditFlowSelect(
                                              e,
                                              field.name,
                                              field,
                                              subsegment,
                                              subsegment.canMultiple,
                                              field.attributeId
                                            )
                                      }
                                      borderColor={
                                        isError
                                          ? "border-redColor"
                                          : "border-sideMenuHelpBox"
                                      }
                                      payloadName={field.name}
                                      apiUrl={field.apiUrl}
                                      // fetchOptions={fetchOptionsDynamic}
                                      setDropdownOptionsDynamic={
                                        setDropdownOptionsDynamicFun
                                      }
                                      dropdownOptionsDynamic={
                                        dropdownOptionsDynamic
                                      }
                                      dependsOn={field.dependsOn}
                                      updatedArray={
                                        isEditMode
                                          ? updatedArrayForEdit.current
                                          : payload
                                      }
                                      setIsSpecialization={setIsSpecialization}
                                      placeholder={`Select ${field?.label}`}
                                      setSpecilizationOptions={
                                        setSpecilizationOptions
                                      }
                                      isRequired={field.isRequired}
                                      value={field?.value}
                                      setSpeclizationIsManditory={setSpeclizationIsManditory}
                                      specilizationIsManditory={speclizationIsManditory}
                                      setBankDetailsManditory={setBankDetailsManditory}
                                      bankDetailsManditory={bankDetailsManditory}
                                    />
                                  ) : (
                                    // Render Input if the inputType is text
                                    <Input
                                      type={
                                        subsegment.name ==
                                        "Bank account details"
                                          ? "password"
                                          : field.inputType
                                      }
                                      name={field.label}
                                      handleOnChange={(e) =>
                                        !isEditMode
                                          ? handleChangeFunction(
                                              e,
                                              field.name,
                                              field,
                                              subsegment,
                                              subsegment.canMultiple,
                                              field.attributeId
                                            )
                                          : handelChangeForEditFlow(
                                              e,
                                              field.name,
                                              field,
                                              subsegment,
                                              subsegment.canMultiple,
                                              field.attributeId
                                            )
                                      }
                                      placeholder={`Enter ${field.label}`}
                                      label={field.label}
                                      borderColor={
                                        isError
                                          ? "border-redColor"
                                          : "border-sideMenuHelpBox"
                                      }
                                      payloadName={field?.name}
                                      isRequired={field?.isRequired}
                                      value={field?.value}
                                      max={field.name === "dateOfBirth" ? todayDate : undefined}
                                      bankDetailsManditory={bankDetailsManditory}
                                      order={order}
                                      editMode={isEditMode}
                                      // isBankDetailsManditoryInEditFlow={isBankDetailsManditoryForEditFlow}
                                    />
                                  )}
                                  {isError && (
                                    <div className="error-message text-red-500">
                                      {errors[field?.name]}
                                    </div>
                                  )}
                                  {phoneNumberExists &&
                                    field?.name === "primaryPhoneNumber" && (
                                      <div className="error-message text-red-500">
                                        "Phone Number already exists"
                                      </div>
                                    )}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                )
              )}
            </div>
          )}
        </div>
      )}
      {isCameraActive && (
        <CameraPopup
          setCapturedImage={setCapturedImage}
          setConfirmedImage={setConfirmedImage}
          videoRef={videoRef}
          capturedFileImage={capturedFileImage}
          captureImage={captureImage}
          capturedImage={capturedImage}
          startCamera={startCamera}
          isVerifyImage={true}
          setIsCameraActive={setIsCameraActive}
          buttonText={""}
          popUpMsg={""}
          popUpTitle={""}
          isOpen={true}
          addImageToUserInfo={addImageToUserInfo}
          onClose={() => {
            setIsCameraActive(false);
          }}
          closeCamera={closeCamera}
        />
      )}
      {!isEditMode && jsonobj?.length === order + 1 && (
        <div className=" bg-consentMessageColor rounded-lg mx-4 md:mx-0 p-3 mt-12 md:mt-24">
          <div className="flex gap-2 md:gap-4 md:pl-4">
            <div className="h-4 w-4 ">
              {" "}
              <InfoIcon />
            </div>
            <div
              className="documentUploadText font-nunito"
              style={{ textAlign: "left" }}
            >
              {OnboardConstants.consentMessage1}{" "}
              <strong>{`“${OnboardConstants.createProfile}“`}</strong>{" "}
              {OnboardConstants.consentMessage2}
              <strong> {OnboardConstants.termsAndcondition}</strong>{" "}
              {OnboardConstants.consentMessage3}
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center">
        {/* {order !== 0 && (
      <div
        className="mt-10 bg-white text-primary flex py-5 border border-primary items-center justify-center w-40 h-8 rounded-lg"
        onClick={onClickToPreviousPage}
      >
        {"Back"}
      </div>
    )} */}
        {!isEditMode && (
          <div
            className="fixed bottom-1 left-1/2 -translate-x-1/2 md:static md:translate-x-0 mt-10 bg-primary text-white ml-8 py-5 flex items-center justify-center w-40 h-8 rounded-lg"
            onClick={onClickToNextPagee}
          >
            {jsonobj?.length === order + 1 ? "Create Profile" : "Next"}
          </div>
        )}
      </div>
      {/* // } */}

      {showCreateProfilePopUp && (
        <PopupModalWithCancelButton
          popUpTitle={StaffListConstants.AreYouSure}
          popUpMsg={"Click the comfirm button to continue"}
          buttonText1={StaffListConstants.Confirm}
          buttonText2={StaffListConstants.Cancel}
          isOpen={showCreateProfilePopUp}
          onCancel={onCancelButtonClick}
          onOkay={onClickToCreateProfile}
          icon={<PopUpIcon />}
        />
      )}
      {showPopUp &&
        (errorUserRegistrationMsg ? (
          <PopupModal
            popUpTitle={
              errorUserRegistrationMsg ??
              StaffListConstants.UserRegisteredMessage
            }
            popUpMsg={OnboardConstants.failedMessage}
            buttonText={StaffListConstants.Okay}
            isOpen={showPopUp}
            onClose={closeModal}
            isSucessMessage={false}
            icon={<ErrorIcon />}
          />
        ) : (
          <PopupModalWithCancelButton
            popUpTitle={
              errorUserRegistrationMsg ??
              StaffListConstants.UserRegisteredMessage
            }
            popUpMsg={
              userConflictingStatus?.conflict === false ||
              userConflictingStatus === null
                ? `The Account is created for the user “${
                    userDetails?.firstName
                  }” for the role “${(userDetails?.baseRoles || [])
                  .map(role => role?.role?.name)
                  .filter(Boolean) // Removes null or undefined values
                  .join(",") }”`
                : "This user details conflicted with the existing user of other dealer. Please click on the conflicted state list for futher action."
            }
            buttonText1={
              isEkycRequired
                ? OnboardConstants.continue
                : OnboardConstants.goBackToDashboard
            }
            buttonText2={OnboardConstants.skip}
            isOpen={showPopUp}
            onCancel={closeModal}
            onOkay={() => {
              dispatch(resetUserRegistrationNewpayload());
              if (isEditMode) {
                setSelectedMenu((selectedMenu ?? 0) + 1);
                setShowPopUp(false);
                dispatch(resetRegisterUserStatus());
                dispatch(reSetUserRegistrationPayload());
              } else if (!isEditMode && isEkycRequired) {
                onClickToNextPage();
                setShowPopUp(false);
              }
            }}
            icon={
              errorUserRegistrationMsg == null ? <PopUpIcon /> : <WarningIcon />
            }
            popUpMsg2={
              isEkycRequired
                ? OnboardConstants.popupMessage
                : OnboardConstants.popUpMessageToGoBackToDashboard
            }
          />
        ))}
      {registerUserStatus === STATUS.LOADING && (
        <LoaderPopupModel isOpen={registerUserStatus === STATUS.LOADING} />
      )}
    </div>
  );
};

export default PersonalInformationDynamic;